import { ApiCreationSource } from "@/types/common.types.ts";
import { TabItem, Tabs } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

const defaultTabSources: (ApiCreationSource | undefined)[] = [
  undefined,
  ApiCreationSource.manual,
  ApiCreationSource.workflow,
];

const tabTitleKeys: Record<string, string> = {
  all: "common:all",
  [ApiCreationSource.manual]: "common:user_created",
  [ApiCreationSource.workflow]: "common:automated",
};

export interface CreationSourceTabsProps {
  value: ApiCreationSource | undefined;
  onChange: (value: ApiCreationSource | undefined) => void;
  sources?: (ApiCreationSource | undefined)[];
}

export const CreationSourceTabs = ({
  value,
  onChange,
  sources = defaultTabSources,
}: CreationSourceTabsProps) => {
  const { t } = useTranslation();
  const activeTab = Math.max(sources.indexOf(value), 0);

  return (
    <Tabs activeTab={activeTab} onActiveTabChange={(index) => onChange(sources[index])}>
      {sources.map((source) => (
        <TabItem key={source ?? "all"} title={t(tabTitleKeys[source ?? "all"])} />
      ))}
    </Tabs>
  );
};
